import { Connections, ObjectColumnFragment } from "src/graphql";
import { ColumnType, Relationship } from "src/types/visual";
import { ModelState } from "src/utils/models";

export type ColumnSettingsProps = {
  isManagedModel: boolean;
  isRealtimeEvent: boolean;
  modelState: ModelState;
  relationships: Relationship[];
  source: {
    definition: Pick<Connections["definition"], "supportsTopK">;
    type: Connections["type"];
  };
  modelId: string;
  columns: ObjectColumnFragment[] | undefined;
  primaryKey?: string;
  onRefetchObject: () => Promise<void>;
};

export enum RealtimeEventColumnTypes {
  String = ColumnType.String,
  Number = ColumnType.Number,
  Boolean = ColumnType.Boolean,
  BigInt = ColumnType.BigInt,
  Date = ColumnType.Date,
  Timestamp = ColumnType.Timestamp,
  JsonArrayStrings = ColumnType.JsonArrayStrings,
  JsonArrayNumbers = ColumnType.JsonArrayNumbers,
  JsonArrayObjects = ColumnType.JsonArrayObjects,
}

export type ColumnFormData = {
  columns: ObjectColumnFragment[];
};
